import { render, staticRenderFns } from "./PopUpSendFile.vue?vue&type=template&id=7338a268&"
import script from "./PopUpSendFile.vue?vue&type=script&lang=js&"
export * from "./PopUpSendFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpSendFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7338a268')) {
      api.createRecord('7338a268', component.options)
    } else {
      api.reload('7338a268', component.options)
    }
    module.hot.accept("./PopUpSendFile.vue?vue&type=template&id=7338a268&", function () {
      api.rerender('7338a268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpSendFile.vue"
export default component.exports